import { VideoErrorStatus } from "@/constants";

let instance = null;
const Offline = class Offline {
  /**
   * @description
   * that : Offline 생성 위치인 VideoBox.vue를 의미함
   * Timeline, LeftMenu, Calendar 등을 컨트롤 하기 위해 $parent로 HLSVideoPlayer를 가져옴
   * rtcViewer : 현재 체결된 rtc Connection을 가져오기 위함
   */
  constructor(that, rtcViewer) {
    if (!that && !rtcViewer) return instance;
    if (that) {
      this.vueInstance = that.$parent; // HLSVideoPlayer를 뜻함
      this.portNo = that.cameraInfo.portNo;
      this.serialCd = that.cameraInfo.serialCd;
      this.clientId = that.webrtcInforms.clientId;
      this.webrtcInforms = that.webrtcInforms;
      this.playPoint = that.playPoint;
    }
    if (rtcViewer) this.rtcViewer = rtcViewer;
    this.recordList = [];
    this.limit = 0;
    instance = this;
    this.init();
  }
  init() {
    this.viewer = this.rtcViewer.viewers.get(this.webrtcInforms.key);
  }
  // send webrtc datachannel message 
  sendMessage(event, data) {
    // this.sendMessage('playback', { timestamp : 1714887937224 });
    // this.sendMessage('timelist', { date : '20240503' });
    if (event === "live") this.s_live();
    else if (event === "playback") this.s_playback(data);
    else if (event === "pause") this.s_pause();
    else if (event === "resume") this.s_resume();
    else if (event === "datelist") this.s_datelist();
    else if (event === "timelist") this.s_timelist(data);
    else if (event === "playbackspeed") this.s_playback_speed(data);
  }
  sendViewerMessage(message) {
    if (!this.viewer) return;
    if (this.viewer.dataChannel) {
      try {
        this.viewer.dataChannel.send(message);
        console.log('[VIEWER] Sent', message, 'to MASTER!');
      } catch (e) {
        console.error('[VIEWER] Send DataChannel:', e.toString());
        return false;
      }
    } else {
      console.warn('[VIEWER] No DataChannel exists!');
      return false;
    }
  }
  s_live() {
    this.instanceStoreControl({ type: 'dispatch', call: 'player/showLoading', data: null} );
    const payload = {
      portNo : this.portNo,
      mode : "Live",
    };
    const packet = {
      topic : `ueyes/iot/${this.serialCd}/request/webrtc/startPlay`,
      clientId : `${this.clientId}`,
      payload : JSON.stringify(payload),
    };
    this.sendViewerMessage(JSON.stringify(packet));
  }
  s_playback(data) {
    this.instanceStoreControl({ type: 'dispatch', call: 'player/showLoading', data: null} );
    const payload = {
      portNo : this.portNo,
      mode : "Playback",
      timestamp : data.timestamp,
    };
    const packet = {
      topic : `ueyes/iot/${this.serialCd}/request/webrtc/startPlay`,
      clientId : `${this.clientId}`,
      payload : JSON.stringify(payload),
    };
    this.sendViewerMessage(JSON.stringify(packet));
  }
  s_pause() {
    const payload = {
      portNo : this.portNo,
    };
    const packet = {
      topic : `ueyes/iot/${this.serialCd}/request/webrtc/playback/pause`,
      clientId : `${this.clientId}`,
      payload : JSON.stringify(payload),
    };
    this.sendViewerMessage(JSON.stringify(packet));
  }
  s_resume() {
    const payload = {
      portNo : this.portNo,
    };
    const packet = {
      topic : `ueyes/iot/${this.serialCd}/request/webrtc/playback/resume`,
      clientId : `${this.clientId}`,
      payload : JSON.stringify(payload),
    };
    this.sendViewerMessage(JSON.stringify(packet));
  }
  s_datelist() {
    const payload = {
      portNo : this.portNo,
    };
    const packet = {
      topic : `ueyes/iot/${this.serialCd}/request/webrtc/playback/timeline/dateList`,
      clientId : `${this.clientId}`,
      payload : JSON.stringify(payload),
    };
    this.sendViewerMessage(JSON.stringify(packet));
  }
  s_timelist(data) {
    const payload = {
      portNo: this.portNo,
      date: data.date,
    };
    const packet = {
      topic : `ueyes/iot/${this.serialCd}/request/webrtc/playback/timeline/timeList`,
      clientId : `${this.clientId}`,
      payload : JSON.stringify(payload),
    };
    this.sendViewerMessage(JSON.stringify(packet));
  }
  s_heartbeat() {
    const payload = {
      portNo: this.portNo,
    };
    const packet = {
      topic : `ueyes/iot/${this.serialCd}/response/webrtc/sessionHeartbeat`,
      clientId: `${this.clientId}`,
      payload: JSON.stringify(payload),
    };
    this.sendViewerMessage(JSON.stringify(packet));
  }
  s_playback_speed(speed) {
    const payload = {
      portNo: this.portNo,
      speed: speed,
    };
    const packet = {
      topic : `ueyes/iot/${this.serialCd}/request/webrtc/playback/speed`,
      clientId : `${this.clientId}`,
      payload: JSON.stringify(payload),
    };
    this.sendViewerMessage(JSON.stringify(packet));
  }
  getTopicAndPayload(evt) {
    const message = evt.data;
    const packet = JSON.parse(message);
    const payload = JSON.parse(packet.payload);
    const topics = packet.topic.toString().toLowerCase().split('/');
    const topic = topics[topics.length - 1];
    return {
      topic: topic,
      payload: payload,
    }
  }
  // receive webrtc datachannel message
  receiveMessageSimple(evt) { // split player 등 타임라인이 없는 곳에서 쓰임
    const { topic, payload } = this.getTopicAndPayload(evt);
    console.log('[VIEWER] Received', evt.data, 'from Master', topic, new Date());
    if (topic !== 'position' && topic !== 'sessionheartbeat' && !this.checkValid(payload)) return;
    if (topic === 'sessionheartbeat') this.r_heartbeat(payload);
    else if (topic === "error") this.r_error(payload);
  }
  receiveMessage(evt) { // 타임라인, 주간 캘린더 등의 다른 컴포넌트가 있을 경우 쓰임
    const { topic, payload } = this.getTopicAndPayload(evt);
    console.log('[VIEWER] Received', evt.data, 'from Master', topic, new Date());
    if (topic !== 'position' && topic !== 'sessionheartbeat' && !this.checkValid(payload)) return;
    if (topic === "startplay") this.r_startplay(payload);
    else if (topic === "playstatus") this.r_playstatus(payload);
    else if (topic === "datelist") this.r_datelist(payload);
    else if (topic === "timelist") this.r_timelist(payload);
    else if (topic === "pause") this.r_pause(payload);
    else if (topic === "resume") this.r_resume(payload);
    else if (topic === "position") this.r_position(payload);
    else if (topic === "sessionheartbeat") this.r_heartbeat(payload);
    else if (topic === "speed") this.r_playback_speed(payload);
    else if (topic === "error") this.r_error(payload);
  }
  checkValid(payload) {
    if (!payload.errorCode) return false;
    if (payload.errorCode !== 'SUCCESS') {
      this.errorProcess(payload);
      return false;
    }
    return true;
  }
  r_startplay(payload) {
    // { portNo: 4, mode: 'Live', errorCode: 'SUCCESS' }
    this.instanceStoreControl({ type: 'dispatch', call: 'player/hideLoading', data: null} );
    console.log('startplay', payload);
  }
  r_playstatus(payload) {
    console.log('playstatus', payload);
  }
  r_datelist(payload) {
    console.log('datelist', payload);
    const dateList = payload.dateList;
    const formatted = [];
    dateList.forEach((ele) => {
      // { portNo: 4, errorCode: 'SUCCESS', dateList: [<TimelineDateInfo>]}
      if (ele.count < 1) return;
      const temp = ele.date.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
      formatted.push(temp);
      this.sendMessage('timelist', { date: temp.replaceAll('-', '')});
    })
    if (formatted.length === 0) formatted.push(new Date().toISOString().substring(0, 10));
    if (this.vueInstance) {
      this.vueInstance.dates = formatted;
      this.vueInstance.changeSwipeDate();
      this.instanceStoreControl({ type: 'commit', call: 'player/SET_RECORDING_PERIOD', data: dateList.length });
      if (dateList.length === formatted.length) {
        this.instanceStoreControl({ type: 'dispatch', call: 'player/updateDateList', data: formatted });
      }
    }
  }
  r_timelist(payload) {
    // { portNo: 4, errorCode: 'SUCCESS', timeList: [<TimelineTimeInfo>]}
    console.log('timelist', payload);
    const timeList = payload.timeList;
    timeList.forEach(ele => {
      const obj = { start: new Date(ele.start), end: new Date(ele.end) };
      const isExist = this.recordList.some(item => JSON.stringify(item) === JSON.stringify(obj));
      if (!isExist) this.recordList.push(obj);
    });
    this.recordList.sort((a, b) => a.start - b.start);
    // console.log('push recordList', this.recordList);
    // this.limit = 5000;
    // if (this.limit === 0) this.limit = this.getRecordListLimitApt();
    // this.limit = this.limit < 10000 ? this.limit : 5000;
    // this.setRecordListSimplify(this.limit);
    // console.log('simplified recordList', this.recordList, this.limit);
    this.instanceStoreControl({ type: 'commit', call: 'player/SET_RECORD_LIST', data: this.recordList });
  }
  r_position(payload) {
    // { portNo: 2, playTimestamp: 1713250376399, position: 1108200, duration: 1800041, startTimestamp: 1713249268199 }
    console.log('position', payload, new Date(payload.playTimestamp), this.vueInstance.player);
    const { playTimestamp, position, duration, startTimestamp } = payload; 
    if (this.vueInstance) {
      this.instanceStoreControl({ type: 'commit', call: 'player/SET_VIDEO_SEGMENT_START_DATE_OBJ', data: new Date(playTimestamp) });
      const tempDiffAdj = this.vueInstance.player.currentTime() - this.vueInstance.playerInitTime;
      this.instanceStoreControl({ type: 'commit', call: 'player/SET_OFFLINE_TIME_DIFF_ADJ', data: tempDiffAdj });
      this.instanceStoreControl({ type: 'dispatch', call: 'player/hideLoading', data: null} );
    }
  }
  r_heartbeat(payload) {
    console.log('heartbeat', payload);
    this.s_heartbeat(); // 받으면 바로 응답하는 것으로 변경
    // setTimeout(() => this.s_heartbeat(), 1000);
  }
  r_error(payload) {
    // { portNo: 2, startTimestamp: 1727223, errorCode: 'FileNotFound' }
    this.instanceStoreControl({ type: 'dispatch', call: 'player/hideLoading', data: null} );
    console.log('error', payload);
  }
  r_pause(payload) {
    // { portNo: 2, errorCode: 'SUCCESS' }
    console.log('pause', payload);
  }
  r_resume(payload) {
    // { portNo: 2, errorCode: 'SUCCESS' }
    console.log('resume', payload);
  }
  r_playback_speed(payload) {
    console.log('playback speed', payload);
    const { duration, playTimestamp, position, speed, startTimestamp } = payload;
    this.instanceStoreControl({ type: 'dispatch', call: 'player/updatePlayRate', data: speed });
  }
  instanceStoreControl(obj) {
    // this.instanceStoreControl({ type: 'dispatch', call: 'player/showLoading', data: null} );
    // this.instanceStoreControl({ type: 'commit', call: 'player/SET_VIDEO_SEGMENT_START_DATE_OBJ', data: });
    const { type, call, data } = obj;
    switch (type) {
      case 'dispatch': 
        if (this.vueInstance && this.vueInstance.$store) this.vueInstance.$store.dispatch(call, data);
        break;
      case 'commit':
        if (this.vueInstance && this.vueInstance.$store) this.vueInstance.$store.commit(call, data);
        break;
    }
  }
  getRecordListLimitApt() { 
    // 30분 단위의 녹화 영상이 들어옴, 녹화간 시간차는 대략 5초 내외, 녹화간 시간차의 평균으로 녹화범위 데이터 갱신
    // TODO: 적절한 대표값을 찾아 적용 필요. 어디서부터 어디까지 필요한 녹화범위인지 기준이 애매함. 
    // 녹화간 중단시간 간격의 평균, 중위값, 최빈값 또는 적당한 값을 찾아 적용하면 좋을 것 같음.
    let total = 0;
    let start, end;
    for (let g = 0; g < this.recordList.length - 1; ++ g) {
      end = this.recordList[g].end;
      start = this.recordList[g + 1].start;
      total += start - end;
    }
    return Math.round(total / (this.recordList.length - 1), 0);
  }
  setRecordListSimplify(limit) { 
    // 하루 이상의 시간(24시간)동안 지속 플레이할 경우 recordList의 array 증가로 수행능력 저하 이슈가 있음.
    // 이 부분은 개선하기 위하여 녹화데이터 간략화를 진행함.
    const simplifiedList = [];
    for (let g = 0; g < this.recordList.length; ++ g) {
      if (simplifiedList.length === 0) {
        simplifiedList.push(this.recordList[g]);
      } else {
        let prevEnd = simplifiedList[simplifiedList.length - 1].end;
        let currentStart = this.recordList[g].start;
        let timeDiff = currentStart.getTime() - prevEnd.getTime();
        if (timeDiff <= limit) {
            simplifiedList[simplifiedList.length - 1].end = this.recordList[g].end;
        } else {
            simplifiedList.push(this.recordList[g]);
        }
      }
    }
    this.recordList = simplifiedList;
  }
  errorProcess(payload) {
    const { errorCode } = payload;
    this.instanceStoreControl({ type: 'dispatch', call: 'player/hideLoading', data: null} );
    switch (errorCode) {
      case "InvalidParameter":
        // if (this.vueInstance) this.vueInstance.showToastMessage('Invalid Parameter');
        if (this.vueInstance) this.vueInstance.showToastMessage("パラメーターが有効ではありません。");
        console.warn("InvalidParameter", payload);
        break;
      case "InvalidRequest":
        /*
         - Live mode 중 pause 요청시
         - Live mode 중 resume 요청시
         - Playback Pause 중 pause 요청시
         - Playback Resume 중 resume 요청시
         */
        //  if (this.vueInstance) this.vueInstance.showToastMessage('Invalid Request');
        if (this.vueInstance) this.vueInstance.showToastMessage("要求が有効ではありません。");
        console.warn("InvalidRequest", payload);
        break;
      case "NotSupported":
        /*
         - 지원하지 않는 기능 (예: Playback 지원하지 않는 요금제에서 Playback 기능을 요청 하는 경우)
         */
        //  if (this.vueInstance) this.vueInstance.showToastMessage('Not Supported');
        if (this.vueInstance) this.vueInstance.showToastMessage("サポートされていない要求です。");
        console.warn("NotSupported", payload);
        break;
      case "ExceededSessionError" : 
        if (this.vueInstance) {
          this.vueInstance.showToastMessage("セッションを超えました。");
          this.instanceStoreControl({ type: 'commit', call: 'player/SET_VIDEO_ERROR', data: VideoErrorStatus.EXCEED_MAX_SESSION });
        }
        console.warn("ExceededSessionError", payload);
        break;
      case "InternalOperationError" :
        console.warn("InternalOperationError", payload);
        break;
      case "PlaybackModeError" : 
        if (this.vueInstance) this.vueInstance.showToastMessage("プレイバックモードの切り替えに失敗しました。");
        console.warn("PlaybackModeError", payload);
        break;
      case "LiveModeError" : 
        if (this.vueInstance) this.vueInstance.showToastMessage("ライブモードの切り替えに失敗しました。");
        console.warn("LiveModeError", payload);
        break;
      case "FileReadError":
        if (this.vueInstance) this.vueInstance.showToastMessage("映像の読み込みに失敗しました。");
        console.warn("FileReadError", payload);
        break;
      case "FileOpenError":
        if (this.vueInstance) this.vueInstance.showToastMessage("映像の開きに失敗しました。");
        console.warn("FileOpenError", payload);
        break;
      case "FileError" : 
        if (this.vueInstance) this.vueInstance.showToastMessage("ファイルエラーがあります。");
        console.warn("FileError", payload);
        break;
      case "FileNotFound":
        if (this.vueInstance) this.vueInstance.showToastMessage("映像が見つかりません。");
        console.warn("FileNotFound", payload);
        break;
      case "SpeedLimitExceededError" :
        this.vueInstance.showToastMessage(`スピードリミットを超えました。 ${payload.changedSpeed}倍スピードでプレイします。`);
        this.instanceStoreControl({ type: 'dispatch', call: 'player/updatePlayRate', data: payload.changedSpeed });
        console.warn("SpeedLimitExceededError", payload);
        break;
    }
  }
};

export default Offline;

// commonPacket = {
//   clientId: '', // string
//   topic: '',  // string
//   payload: {}, // object
// };
// timelineDateInfo = {
// date: '', // string
// count: 0, // integer
// };
// timelineTimeInfo = {
// start: 0, // timestamp
// end: 0, // timestamp
// duration: 0, // long
// };
